"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationLayer_1 = require("./AnimationLayer");
var TextAnimatorData_1 = require("../text/TextAnimatorData");
var TextLayer = (function (_super) {
    tslib_1.__extends(TextLayer, _super);
    function TextLayer(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.findFirstKeyFrame = function () {
            if (_this.data && _this.data.data && _this.data.data.keyframes && _this.data.data.keyframes.length > 0) {
                return _this.data.data.keyframes[0];
            }
            return undefined;
        };
        _this.findFirstText = function () {
            var keyFrame = _this.findFirstKeyFrame();
            return keyFrame === undefined ? undefined : keyFrame.start.text;
        };
        _this.replaceText = function (text) {
            if (_this.data && _this.data.data && _this.data.data.keyframes) {
                _this.data.data.keyframes.forEach(function (keyframe) {
                    keyframe.start.text = text;
                });
            }
        };
        _this.replaceFontColor = function (fontColor) {
            if (_this.data && _this.data.data && _this.data.data.keyframes) {
                _this.data.data.keyframes.forEach(function (keyframe) {
                    keyframe.start.fontColor = fontColor;
                });
            }
        };
        if (_this._rawData.t) {
            _this.data = new TextAnimatorData_1.TextAnimatorData(_this._rawData.t, version);
        }
        return _this;
    }
    return TextLayer;
}(AnimationLayer_1.AnimationLayer));
exports.TextLayer = TextLayer;
//# sourceMappingURL=TextLayer.js.map